import jQuery from 'jquery';
import Device from '@/models/v5/device';
var Dut = Device.extend({
    initialize: function () {
        var ret_val = Device.prototype.initialize.call(this);
        this.type = Dut.type;
        return ret_val;
    },
    /**
     * DUTs have no real API endpoint. The only way to get 
     * information about a DUT is to fetch the collection
     * it belongs to.
     *
     * Here we trust that the fetch command on the collection
     * will update any information for this specific DUT.
     */
    fetch: function() {
        return jQuery.Deferred().resolve();
        // return this.collection.fetch();
    }
});
Dut.type = 'dut';
export default Dut;

